import { AuthorMap } from "./authorAction";

const initialState = {
  isLoading: false,
  authorListTotal: [],
  refreshAuthor: true,
  selectedAuthor: {},
  reDirect: false,
  searchBy: "",
  searchText: "",
  authors: [],
  skip: 0,
  limit: 10,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case AuthorMap.ADD_AUTHOR_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case AuthorMap.ADD_AUTHOR_SUCCESS: {
      return {
        ...state,
        refreshAuthor: true,
        reDirect: true,
      };
    }
    case AuthorMap.ADD_AUTHOR_ERROR: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case AuthorMap.GET_ALL_AUTHOR_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case AuthorMap.GET_ALL_AUTHOR_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        refreshAuthor: false,
        authorListTotal: action.payload,
      };
    }
    case AuthorMap.GET_ALL_AUTHOR_ERROR: {
      return {
        ...state,
        isLoading: false,
        refreshAuthor: false,
      };
    }
    case AuthorMap.UPDATE_AUTHOR_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case AuthorMap.UPDATE_AUTHOR_SUCCESS: {
      return {
        ...state,
        refreshAuthor: true,
        selectedAuthor: {
          ...state.selectedAuthor,
          ...action.payload,
        },
        reDirect: true,
      };
    }
    case AuthorMap.UPDATE_AUTHOR_ERROR: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case AuthorMap.DELETE_AUTHOR_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case AuthorMap.DELETE_AUTHOR_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        refreshAuthor: true,
      };
    }
    case AuthorMap.DELETE_AUTHOR_ERROR: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case AuthorMap.SEARCH_TEXT_CHANGE: {
      return {
        ...state,
        searchText: action.payload,
      };
    }
    case AuthorMap.REFRESH_AUTHOR_LIST: {
      return {
        ...state,
        skip: 0,
        refreshAuthor: true,
      };
    }
    case AuthorMap.GET_AUTHOR_DETAIL_START: {
      return {
        ...state,
        isLoading: true,
        selectedAuthor: {},
      };
    }
    case AuthorMap.GET_AUTHOR_DETAIL_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        selectedAuthor: action.payload,
        refreshAuthor: false,
      };
    }
    case AuthorMap.GET_AUTHOR_DETAIL_ERROR: {
      return {
        ...state,
        isLoading: false,
        refreshAuthor: false,
      };
    }
    case AuthorMap.GET_AUTHOR_LIST_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case AuthorMap.GET_AUTHOR_LIST_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        authors: action.payload,
      };
    }
    case AuthorMap.GET_AUTHOR_LIST_ERROR: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case AuthorMap.SET_AUTHOR_BATCH_NUMBER: {
      return {
        ...state,
        skip: action.payload,
        refreshAuthor: true,
      };
    }
    default:
      return { ...state };
  }
};
